var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('list-search', _vm._b({
    on: {
      "search": _vm.emit
    }
  }, 'list-search', {
    loading: _vm.loading,
    showsSearch: _vm.showsSearch
  }, false), [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "date",
      "max": "2999-12-31",
      "label": "작성일(시작)",
      "clearable": ""
    },
    model: {
      value: _vm.query.searchDateValue[0],
      callback: function ($$v) {
        _vm.$set(_vm.query.searchDateValue, 0, $$v);
      },
      expression: "query.searchDateValue[0]"
    }
  }, 'v-text-field', _vm.attrs_input__console, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('v-text-field', _vm._b({
    attrs: {
      "type": "date",
      "max": "2999-12-31",
      "label": "작성일(종료)",
      "clearable": ""
    },
    model: {
      value: _vm.query.searchDateValue[1],
      callback: function ($$v) {
        _vm.$set(_vm.query.searchDateValue, 1, $$v);
      },
      expression: "query.searchDateValue[1]"
    }
  }, 'v-text-field', _vm.attrs_input__console, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('autocomplete-board', _vm._g(_vm._b({
    attrs: {
      "label": "게시글",
      "sort": {
        subject: 1,
        _id: -1
      },
      "placeholder": "전체",
      "clearable": ""
    },
    model: {
      value: _vm.query['_board'],
      callback: function ($$v) {
        _vm.$set(_vm.query, '_board', $$v);
      },
      expression: "query['_board']"
    }
  }, 'autocomplete-board', Object.assign({}, _vm.attrs_input__console, {
    params: _vm.boardParams
  }), false), {
    emit: _vm.emit
  }))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "sm": "6",
      "lg": "3"
    }
  }, [_c('autocomplete-user', _vm._g(_vm._b({
    attrs: {
      "label": "작성자",
      "itemText": function (_ref) {
        var name = _ref.name,
          username = _ref.username;
        return `${name} (${username})`;
      },
      "sort": {
        name: 1,
        username: 1,
        _id: -1
      },
      "placeholder": "전체",
      "clearable": ""
    },
    model: {
      value: _vm.query['writer._id'],
      callback: function ($$v) {
        _vm.$set(_vm.query, 'writer._id', $$v);
      },
      expression: "query['writer._id']"
    }
  }, 'autocomplete-user', Object.assign({}, _vm.attrs_input__console), false), {
    emit: _vm.emit
  }))], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }